/*
 * @author Hong-Phuc Bui
 * @filename js-parser
 * Initial Date 12.02.19
 */

//import acorn from "acorn"; funktioniert nicht!
let acorn = require("acorn");

/**
 * check if jsCode contain Syntax Error
 *
 * @param jsCode:String
 * */
export function checkSyntaxError(jsCode) {
    if (jsCode === null || jsCode === undefined || jsCode.length === 0) {
        return {
            "message": "JavaScript Code is null or empty",
            "line": -1,
            "column": -1
        };
    }
    try {
        acorn.parse(jsCode, {
            sourceType: "script"
        });
        return null;
    } catch (e) {
        if (e instanceof SyntaxError) {
            return {
                "message": e.message,
                "line": e.loc.line,
                "column": e.loc.column
            };
        } else {
            return {
                "message": "Parser JS Code error: " + e.message,
                "line": -1,
                "column": -1
            };
        }
    }
}